import { render } from "./index.vue?vue&type=template&id=e5b6873a&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=e5b6873a&scoped=true&lang=css"

import exportComponent from "D:\\project\\item\\jts\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e5b6873a"]])

export default __exports__